var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[(_vm.$nuxt.isOffline)?_c('v-system-bar',{staticClass:"justify-center",attrs:{"dark":"","color":"error","app":""}},[_c('v-icon',[_vm._v("mdi-minus-circle")]),_vm._v(" "),_c('span',[_vm._v("No Internet. Please reconnect again.")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }